import React from 'react';
import { IconContainer } from './IconContainer';

const AddPackageIcon = (props) => {
    return (
        <IconContainer ariaLabel="add-package" {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 5H12V7H4V5Z M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 12V9H13V12H16V14H13V17H11V14H8V12H11Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { AddPackageIcon };